
/**
 * Utility function to format message content for email and clipboard
 * Removes markdown formatting and improves spacing for better readability
 */
export const formatForEmailAndClipboard = (content: string): string => {
  if (!content) return '';
  
  // Remove any markdown code block syntax first
  let formattedContent = content
    .replace(/^```markdown\s*\n?/i, '')
    .replace(/^```\s*\n?/, '')
    .replace(/\n?```\s*$/i, '');
  
  // Remove markdown formatting
  formattedContent = formattedContent
    // Convert **text** to plain text without asterisks 
    .replace(/\*\*(.*?)\*\*/g, '$1')
    // Convert *text* to plain text without asterisks
    .replace(/\*(.*?)\*/g, '$1')
    // Ensure proper spacing around headings and sections
    .replace(/([A-Z][A-Za-z\s]+):(\s*)/g, '\n$1:\n')
    // Replace markdown bullet points with proper plain text bullets
    .replace(/•\s+/g, '• ')
    .replace(/^\s*-\s+/gm, '• ')
    .replace(/^\s*\*\s+/gm, '• ')
    // Fix any double line breaks that might have been created
    .replace(/\n\s*\n\s*\n/g, '\n\n')
    // Ensure "SUMMARY:" has proper spacing
    .replace(/SUMMARY:/g, '\nSUMMARY:\n')
    // Ensure "NOTE:" has proper spacing
    .replace(/NOTE:/g, '\nNOTE:\n')
    // Handle section titles that might be in bold
    .replace(/(Key Points|Next Steps|Order Issue|Consumer Rights|Refund Request):/g, '\n$1:\n');
  
  // Add proper spacing around bullet points
  formattedContent = formattedContent
    .split('\n')
    .map(line => {
      if (line.trim().startsWith('•')) {
        return `  ${line.trim()}`;
      }
      return line;
    })
    .join('\n');
  
  // Ensure proper spacing at the beginning and end
  formattedContent = formattedContent.trim();
  
  return formattedContent;
};
